/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const EyeHide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Eye hide"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M19.718 5.517a.89.89 0 0 0 0-1.257.885.885 0 0 0-1.254 0L4.282 18.483a.89.89 0 0 0 0 1.257.885.885 0 0 0 1.254 0zM2.62 10.183c3.532-4.556 8.04-6.171 12.264-4.846L13.424 6.8A7.7 7.7 0 0 0 12 6.667c-2.647 0-5.493 1.399-7.98 4.607a1.185 1.185 0 0 0 0 1.45q.812 1.044 1.664 1.838L4.431 15.82a17 17 0 0 1-1.81-2.004 2.97 2.97 0 0 1 0-3.633M12 17.333q-.705 0-1.424-.134l-1.46 1.464c4.224 1.325 8.732-.29 12.263-4.846a2.97 2.97 0 0 0 0-3.633 17 17 0 0 0-1.81-2.004l-1.253 1.258q.852.793 1.663 1.837c.33.426.33 1.024 0 1.45-2.486 3.209-5.332 4.609-7.979 4.608"
      className="SVG"
    />
  </svg>
);

export const EyeHideIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'eye-hide-icon'}
      icon={EyeHide}
      {...props}
      size={size}
    />
  );
};
